/*
    Create by fanglijuan 2017-05-25
*/
'use strict';
angular.module("modifyAccountSynchroToGroupModule", [])
    .controller("modifyAccountSynchroToGroupCtrl", ["$scope", "$location", "$stateParams", "$q", "$filter", "$timeout", "$modalInstance", "trsHttpService", 'treeService', "$state", "$validation", "trsspliceString", "globleParamsSet", "accountSynchroToGroupService", "modalDialog", "item",'nameChange',
        function($scope, $location, $stateParams, $q, $filter, $timeout, $modalInstance, trsHttpService, treeService, $state, $validation, trsspliceString, globleParamsSet, accountSynchroToGroupService, modalDialog, item,nameChange) {
            initStatus();
            initData();

            function initStatus() {
                $scope.status = {
                    groupName: item.DEPARTNAME,
                    synGroupId: item.SYNGROUPID,
                    groupId: 0,
                };
                $scope.data = {
                    globalName:nameChange.globalName,
                    modalTitle: "组织同步",
                    "navTitle": "修订",
                    currGroup: [],
                    currMLFGroup: [],
                };
            }
            /**
             * [initData description]初始化数据
             */
            function initData() {
                getSynGroupDetail();
            }
            /**
             * [getSynGroupDetail description]
             * @return {[type]} [description]
             */
            function getSynGroupDetail() {
                var params = {
                    "serviceid": "mlf_groupmanagement",
                    "methodname": "getSynGroupDetail",
                    "SynGroupId": $scope.status.synGroupId
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    $scope.data.currGroup = data;
                });
            }


            //修订：点击确定
            $scope.confirm = function() {
                saveGroup($scope.data.currGroup).then(function(data) {
                    modalDialog.alertType('同步成功', "", "success", false, function() {
                        $modalInstance.close(data);
                    });
                });
            };

            function saveGroup(newGroup) {
                var defer = $q.defer();
                var params = {
                    serviceid: "mlf_groupmanagement",
                    methodname: "saveSynGroup",
                    SynGroupId: $scope.status.synGroupId,
                    GroupId: newGroup.SYNGROUPID, //修订
                    ParentId: newGroup.SYNPARENTID,//父组织id
                    GNAME: newGroup.DEPARTNAME,
                    GDESC: newGroup.DEPARTDESC,
                    //EMAIL: newGroup.EMAIL,
                    isUnit: 0, //是否为独立媒体：默认0
                    configuration: 0, //大屏统计:默认0不统计
                    DepartId: newGroup.DEPARTID, //8531组织ID和MLF组织ID一致［必传］
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                    data = data.replace(/\"/g, "")
                    defer.resolve(data);
                });
                return defer.promise;
            }
            //取消
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
        }
    ]);
